import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import {
  financialCalculators,
  fitnessCalculators,
  mathCalculators,
  otherCalculators
} from '../data/mock';

const SitemapPage = () => {
  const CategorySection = ({ title, calculators }) => (
    <div className="mb-10">
      <h2 className="text-xl font-bold text-white mb-4 pb-3 border-b border-[#2a2a2a]">{title}</h2>
      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {calculators.map((calc, index) => (
          <li key={index}>
            <Link
              to={calc.path}
              className="text-gray-400 hover:text-cyan-400 transition-colors text-sm flex items-center gap-2"
            >
              <span className="w-1 h-1 bg-cyan-500 rounded-full" />
              {calc.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />

      <main className="flex-1">
        <div className="max-w-5xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">All Calculators</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-8">All Calculators - Sitemap</h1>

          <CategorySection title="Financial Calculators" calculators={financialCalculators} />
          <CategorySection title="Fitness & Health Calculators" calculators={fitnessCalculators} />
          <CategorySection title="Math Calculators" calculators={mathCalculators} />
          <CategorySection title="Other Calculators" calculators={otherCalculators} />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default SitemapPage;
